import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "type", "placeholder", "min", "maxlength", "value"]

import { isEventTargetValueNumber } from '@/helpers/isEventTargetValueNumber'


const __default__ = {
    inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  props: {
    maxCharacterCount: {},
    modelValue: {}
  },
  setup(__props: any) {

// eslint-disable-next-line import/first


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps({
    id: "$attrs.id",
    disabled: _ctx.$attrs.disabled as boolean,
    type: _ctx.$attrs.type as string || 'text',
    placeholder: (_ctx.$attrs.placeholder as string),
    min: _ctx.$attrs.min as number,
    maxlength: _ctx.maxCharacterCount,
    value: _ctx.modelValue
  }, _ctx.$attrs, {
    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
    onKeypress: _cache[0] || (_cache[0] = (e) => _ctx.$attrs.type === 'number' && _unref(isEventTargetValueNumber)(e)),
    onInput: _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:modelValue', e.target.value))
  }), null, 16, _hoisted_1))
}
}

})